// import {combineRducer} from "redux-immutable";
import contact from './ContactReducer';

/*
const contact = combineRducer({
    contact
})
*/
export default contact;
